<template>
  <div class="compact-form">
    <osv-app-alert osv-alert-position="osv-alert-relative" />
    <form @submit.prevent="signUpFromInvitation">
      <alert-message
        :messages="errorMessage"
        type="danger"
        ref="osvAlertMessage"
      />

      <!-- Email -->
      <div class="form-group">
        <b-field
          :label="$t('email')"
          custom-class="required"
          label-position="on-border"
        >
          <b-input required v-model="email" type="email"></b-input>
        </b-field>
      </div>

      <!-- Password -->
      <div class="form-group">
        <b-field
          :label="$t('password')"
          custom-class="required"
          label-position="on-border"
          :message="$t('passwordRules')"
        >
          <b-input
            required
            v-model="password"
            type="password"
            :password-reveal="true"
          />
        </b-field>
      </div>

      <!-- Confirm password -->
      <div class="form-group">
        <b-field
          :label="$t('confirmPassword')"
          custom-class="required"
          label-position="on-border"
        >
          <b-input
            required
            v-model="confirmPassword"
            type="password"
            :password-reveal="true"
          />
        </b-field>
      </div>

      <!-- Checkbox list -->
      <div class="form-group">
        <b-checkbox v-model="acceptGdpr">
          {{ $t("acceptGdpr") }}
        </b-checkbox>
        <br />
        <a
          :href="this.osvConfig.paths.gdprCustomer"
          v-if="this.osvConfig.paths.gdprCustomer"
          target="_blank"
        >
          {{ $t("gdpr") }}
        </a>
      </div>

      <div class="form-group text-right">
        <b-button
          outlined
          rounded
          type="is-primary"
          :loading="loadingCreated"
          native-type="submit"
        >
          {{ $t("create") }}
        </b-button>
      </div>
    </form>
  </div>
</template>

<script>
import { HelpersMixin } from "@/mixins/HelpersMixin";
import { ConfigMixin } from "@/mixins/ConfigMixin";
import { LocaleMixin } from "@/mixins/LocaleMixin";
import { PhoneNumberMixin } from "@/mixins/PhoneNumberMixin";
import store from "@/store";
import VueI18n from "vue-i18n";
import cug from "@/services/cug";
import AlertMessage from "../shared/AlertMessage";
import OsvAppAlert from "@/components/shared/OsvAppAlert";

export default {
  store,
  name: "SignUpFromInvitationForm",
  mixins: [
    LocaleMixin,
    HelpersMixin,
    ConfigMixin,
    PhoneNumberMixin
  ],
  components: { OsvAppAlert, AlertMessage },

  data() {
    return {
      tenant: "",

      email: "",
      password: "",
      confirmPassword: "",
      invitationToken: null,

      acceptGdpr: false,

      loadingCreated: false,

      errorMessage: []
    };
  },

  created() {
    let urlParams = new URLSearchParams(window.location.search);
    this.invitationToken = urlParams.get("invitation_token");
    this.email = urlParams.get("email");
  },

  methods: {
    signUpFromInvitation: function() {
      this.errorMessage = [];

      if (!this.acceptGdpr) {
        this.errorMessage = [
          this.$t("youMustAcceptGdpr", { name: this.tenant })
        ];
        return false;
      }

      if (this.loadingCreated) { return false; }
      this.loadingCreated = true;

      const data = {
        invitationToken: this.invitationToken,
        email: this.email,
        password: this.password,
        passwordConfirmation: this.confirmPassword
      }

      store
        .dispatch("auth/createAccountFromInvitation", data)
        .then(() => {
          if (this.osvConfig.paths.account) {
            document.location.href = this.osvConfig.paths.account;
          } else {
            document.location.href = '/';
          }
        })
        .catch(err => {
          this.$root.$emit('OsvAlert_ErrorFromApi', err, 'online_account')
        })
        .finally(() => {
          this.loadingCreated = false;
        });
    }
  },

  beforeMount() {
    cug.whoami().then(rep => {
      this.tenant = rep.data.name;
    });
  },

  // Translate component
  mounted() {
    this.$i18n.locale = this.getLocale();
  },
  i18n: new VueI18n({
    locale: "fr",
    messages: {
      en: {
        email: "Email",
        password: "Password",
        confirmPassword: "Confirm password",
        create: "Create my account",
        acceptGdpr:
          "I have read and agree to the processing of my personal data",
        gdpr: "Data Management Policy",
        youMustAcceptGdpr: "You must accept the {name}'s data management policy",
        passwordRules: "should contain : 8 characters, 1 lowercase, 1 uppercase, 1 digit"
      },
      fr: {
        email: "Email",
        password: "Mot de passe",
        confirmPassword: "Confirmer le mot de passe",
        create: "Créer mon compte",
        acceptGdpr:
          "J'ai lu et j'accepte le traitement de mes données personnelles",
        gdpr: "Politique de gestion des données",
        youMustAcceptGdpr:
          "Vous devez accepter la politique de gestion des données de {name}",
        passwordRules: "doit contenir : 8 caractères, 1 minuscule, 1 majuscule, 1 chiffre"
      }
    }
  })
};
</script>

<style lang="scss" src="../../assets/styles/buefy/base.scss"></style>
